exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button.VueCarousel-navigation-button.VueCarousel-navigation-next,button.VueCarousel-navigation-button.VueCarousel-navigation-prev{-webkit-transform:none;transform:none}.carousel-wrapper{width:100%}.image-block{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.VueCarousel-slide{visibility:visible;-ms-flex-preferred-size:100%;flex-basis:100%}.nav-arrow{font-size:32px;color:#fff;padding:0 20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2b93d771","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/projects/CarouselWrapper.vue
// module id = nuL5
// module chunks = 1